import { render, staticRenderFns } from "./ConsultaChat.vue?vue&type=template&id=f563ae70&scoped=true"
import script from "./ConsultaChat.vue?vue&type=script&lang=js"
export * from "./ConsultaChat.vue?vue&type=script&lang=js"
import style0 from "./ConsultaChat.vue?vue&type=style&index=0&id=f563ae70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f563ae70",
  null
  
)

export default component.exports